(function($) {

	$.fn.msxiAddClear = function(options) {

		// build main options before element iteration
		options = $.extend(true, {}, $.fn.msxiAddClear.defaults, options);

		return this.each(function() {
			var $this = $(this);

			// build element specific options
			$this.options = $.metadata ? $.extend(true, {}, options, $this.metadata()) : options;
			//noinspection JSValidateTypes
			$this.options = $.fn.dataset ? $.extend(true, $this.options, $this.dataset()) : $this.options;

			$this.addClear($this.options.addClear);
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxiAddClear.defaults = {
		addClear: {
			closeSymbol: "&#10006;",
			returnFocus: true,
			showOnLoad: true,
			onClear: function($input) {
				if($input.is('.date-picker')) {
                    // if the input is a date-picker we have to explicitly set the date to null to ensure the hidden
					// field is updated
                    $input.datepicker('setDate', null);
				}
				else if($input.is('.time-picker')) {
                    // if the input is a time-picker we have to explicitly set the date to '' to ensure the hidden
					// field is updated
                    $input.timepicker('setTime', '');
				}
			},
			hideOnBlur: false
		}
	};

})(jQuery);